import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39ab68fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hello" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Para acesso ao ambiente corporativo "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://cliente.valetexpress.com.br",
    target: "_blank",
    rel: "noopener"
  }, "clique aqui"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Quer saber mais sobre a plataforma?", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Entre em contato com nosso suporte via Whatsapp: 55 (44) 998637570 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.msg), 1),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}